<template>
  <div class="html-preview-custom-field" ref="htmlPreviewContainer">
    <div class="d-flex align-items-center gap-2">
      <span class="text-truncate flex-grow-1" ref="textSpan" :title="plainTextPreview || presenter || ''">
        {{ plainTextPreview || '—' }}
      </span>
      <b-button
        v-if="hasValue && isTruncate"
        class="btn btn-icon btn-light btn-hover-primary st-btn-data-table my-1"
        @click.stop="openPreview"
        :aria-label="$t('GENERAL.ACTIONS.VIEW') || 'View'"
      >
        <span class="st-data-table-icon svg-icon svg-icon-md svg-icon-primary">
          <i class="fas fa-eye"></i>
        </span>
      </b-button>
    </div>

    <b-modal
      v-if="hasValue"
      v-model="isModalOpen"
      :id="modalId"
      :title="$t('GENERAL.ACTIONS.VIEW') || 'View'"
      size="lg"
      hide-footer
      @hidden="onModalHidden"
    >
      <div class="html-preview-html" v-html="sanitizedHtml"></div>
    </b-modal>
  </div>
</template>

<script>
import DOMPurify from 'dompurify';
import { stripHtml, hasHtmlContent } from '@/shared/utils/html';

export default {
  name: 'HtmlPreviewCustomField',
  props: {
    presenter: {
      type: [String, Boolean, Number],
      default: '',
    },
    dataObj: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isTruncate: false,
      isModalOpen: false,
    };
  },
  computed: {
    hasValue() {
      return this.presenter !== null && this.presenter !== undefined && this.presenter !== false && this.presenter !== '';
    },
    modalId() {
      const fieldKey = this.dataObj?.field?.key || 'editor';
      const index = this.dataObj?.index ?? 0;
      return `${fieldKey}-${index}-preview`;
    },
    plainTextPreview() {
      if (!this.hasValue) {
        return '';
      }

      const text = hasHtmlContent(String(this.presenter)) ? stripHtml(String(this.presenter)) : String(this.presenter);
      return text.length > 120 ? `${text.slice(0, 117).trim()}...` : text;
    },
    sanitizedHtml() {
      if (!this.hasValue) {
        return '';
      }

      return DOMPurify.sanitize(String(this.presenter));
    },
  },
  watch: {
    plainTextPreview() {
      this.$nextTick(this.updateTruncateState);
    },
  },
  mounted() {
    this.updateTruncateState();
    this.resizeObserver = new ResizeObserver(() => this.updateTruncateState());
    this.resizeObserver.observe(this.$refs.htmlPreviewContainer);
  },
  beforeDestroy() {
    this.resizeObserver?.disconnect();
  },
  methods: {
    updateTruncateState() {
      const span = this.$refs.textSpan;
      this.isTruncate = !!span && span.scrollWidth > span.offsetWidth;
    },
    openPreview() {
      this.isModalOpen = true;
    },
    onModalHidden() {
      this.isModalOpen = false;
    },
  },
};
</script>

<style scoped>
.html-preview-custom-field {
  min-width: 0;
}

.html-preview-html {
  word-break: break-word;
}
</style>
